import { render, staticRenderFns } from "./adminOwnerList.vue?vue&type=template&id=0079e895&scoped=true"
import script from "./adminOwnerList.vue?vue&type=script&lang=js"
export * from "./adminOwnerList.vue?vue&type=script&lang=js"
import style0 from "./adminOwnerList.vue?vue&type=style&index=0&id=0079e895&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0079e895",
  null
  
)

export default component.exports